<template>
  <div>
    <b-row>
      <b-col>
        <h3 class="text-center">
          {{ title }}
        </h3>
      </b-col>
    </b-row>
    <b-card-group deck class="flex-center">
      <card
        v-for="item in items"
        v-bind:card="item"
        :id="item.name + '-' + item.value"
        v-bind:selectedValue="selectedValue"
        v-on:cardSelected="$emit('cardSelected', item)"
        v-bind:key="item.img">
      </card>
    </b-card-group>
  </div>
</template>

<script>
import Card from '@/components/utils/Card';

export default {
  components: {
    Card,
  },
  props: {
    title: String,
    items: Array,
    selectedValue: String,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/CardList.vue